import styled, { css } from 'styled-components';
import { device, size } from 'styles/device';

export const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${props => props.theme.background};

  border-top: 2px solid ${props => props.theme.button.primary.out};
`;

export const Container = styled.div`
  /* display: flex; */
  padding: 0;
  padding-top: 66px;
`;

export const Item = styled.li`
  position: relative;

  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 15px 0 15px 1.76rem;

  cursor: pointer;

  a {
    min-height: 23px;
    display: flex;
    flex: 1;
    flex-direction: row;
    align-items: center;
    width: ${props => (props.$mini ? '48px' : '200px')};
    color: ${props => props.theme.lightFontColor};
    svg {
      min-width: 20px !important;
    }
    span {
      display: flex;
      position: ${props => (props.$mini ? 'absolute' : 'relative')};

      align-items: center;
      justify-content: space-between;
      padding-right: 20px;
      width: ${props => (props.$mini ? '48px' : '100%')};
      color: ${props => props.theme.lightFontColor};

      p {
        ${props =>
          props.$mini
            ? css`
                margin-left: 10px;

                -webkit-transform: translate3d(-25px, 0, 0);
                transform: translate3d(-25px, 0, 0);
                opacity: 0;
              `
            : css`
                margin-left: 10px;
                -webkit-transition: all 0.2s ease 0s;
                transition: all 0.2s ease 0s;
                -webkit-transform: translateZ(0);
                transform: translateZ(0);
                opacity: 1;
                /* color: #fff; */
              `}
      }

      b {
        opacity: ${props => (props.$mini ? 0 : 1)};
        ${props =>
          props.$collapse
            ? css`
                transition: all 0.3s ease-in-out 0s;
                transform: rotate(180deg);
              `
            : css`
                transition: all 0.3s ease-in-out 0s;
                transform: rotate(360deg);
              `};
        width: 0;
        height: 0;
        vertical-align: middle;
        border-top: 4px dashed;
        border-right: 4px solid transparent;
        border-left: 4px solid transparent;
      }
    }
  }
  button {
    background: transparent;
    border: none;
    min-height: 23px;
    display: flex;
    flex: 1;
    flex-direction: row;
    align-items: center;
    width: 200px;
    color: ${props => props.theme.lightFontColor};
    svg {
      min-width: 20px !important;
    }
    span {
      min-width: 180px;
      display: flex;
      position: relative;

      align-items: center;
      justify-content: space-between;
      padding-right: 20px;
      width: ${props => (props.$mini ? '48px' : '100%')};
      color: ${props => props.theme.lightFontColor};

      p {
        ${props =>
          props.$mini
            ? css`
                margin-left: 10px;

                -webkit-transform: translate3d(-25px, 0, 0);
                transform: translate3d(-25px, 0, 0);
                opacity: 0;
              `
            : css`
                margin-left: 10px;
                -webkit-transition: all 0.2s ease 0s;
                transition: all 0.2s ease 0s;
                -webkit-transform: translateZ(0);
                transform: translateZ(0);
                opacity: 1;
                /* color: #fff; */
              `}
      }

      b {
        opacity: ${props => (props.$mini ? 0 : 1)};
        ${props =>
          props.$collapse
            ? css`
                transition: all 0.3s ease-in-out 0s;
                transform: rotate(180deg);
              `
            : css`
                transition: all 0.3s ease-in-out 0s;
                transform: rotate(360deg);
              `};
        width: 0;
        height: 0;
        vertical-align: middle;
        border-top: 4px dashed;
        border-right: 4px solid transparent;
        border-left: 4px solid transparent;
      }
    }
  }

  svg {
    font-size: 1.2625rem !important;
    stroke-width: 1.4px;
    /* color: #fff; */
  }

  h5 {
    -webkit-transition: all 0.3s ease 0s;
    transition: all 0.3s ease 0s;
    margin-left: -20px;
    min-width: 21px;
    color: #fff !important;
    opacity: ${props => (props.$mini ? 1 : 0)};
  }

  div {
    margin-left: -1.76rem !important;
    position: relative;
    overflow: hidden;
    height: auto;
    transition: max-height 0.25s ease-out;
    flex-direction: column;

    -webkit-transition: max-height 0.25s ease;
    -moz-transition: max-height 0.25s ease;
    -o-transition: max-height 0.25s ease;

    margin: 0;
    ${props =>
      props.$collapse
        ? css`
            opacity: 1;
            /* max-height: 250px; */
          `
        : css`
            opacity: 1;
            max-height: 0px;
          `}

    ul {
      li {
        /* padding: 0; */
        padding: 15px 0 0px 2.9rem !important;
        align-items: flex-start !important;
      }
    }
  }

  ${props =>
    props.$active
      ? css`
          &::before {
            opacity: ${props => (props.type === 'collapsed' ? 0.6 : 0.8)};
            content: ' ';
            position: absolute;
            height: 6px;
            width: 6px;
            top: 20px;
            left: 10px;
            background: #fff;
            border-radius: 50%;
          }
        `
      : css`
          opacity: ${props => (props.type === 'collapsed' ? 0.8 : 0.8)};
        `}

  &:hover {
    opacity: 1;
  }
`;

export const SideBar = styled.div`
  width: ${props => (props.$mini ? '75px' : '230px')};
  height: calc(100vh - 90px);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  background-size: cover;
  background-position: 50%;
  display: block;
  box-shadow: 0 2px 22px 0 rgba(0, 0, 0, 0.1), 0 4px 20px 0 rgba(0, 0, 0, 0.15);
  margin-top: 68px;
  margin-left: 15px;
  border-radius: 5px;

  transition: 0.1s ease-in-out 0s;
  transition-property: width, transform, visibility;
  background: ${props => props.theme.menu.in}; /*#ba54f5;*/
  background: -webkit-gradient(
    linear,
    left bottom,
    left top,
    from(${props => props.theme.menu.in}),
    to(${props => props.theme.menu.out})
  );
  background: linear-gradient(
    0deg,
    ${props => props.theme.menu.in},
    ${props => props.theme.menu.out}
  );

  @media ${device.laptopM} {
    height: 100%;
    margin-left: 0px;
    z-index: 1000 !important;

    transition: 0.275s ease-out 0s;
    transition-property: width, transform, visibility;
    ${props =>
      props.$mini
        ? css`
            transform: translateX(-90px);
            visibility: hidden;
          `
        : css`
            transform: translateX(0);
            visibility: visible;
          `}
  }

  div {
    &:first-of-type {
      width: 100%;
    }
  }

  p {
    opacity: 0;
    color: #fff;
    text-transform: uppercase;
  }

  &::before {
    content: '';
    position: absolute;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid ${props => props.theme.button.primary.out};
    top: -5px;
    left: 40px;
    -webkit-transform: translate(-50%);
    transform: translate(-50%);
  }

  &:hover ${Item} {
    a {
      height: 22px;
      width: 200px;
      svg {
        min-width: 20px !important;
      }
      span {
        position: relative;
        width: 100%;
      }
    }
  }

  // caso seja maior que laptopM quer dizer que a sidebar nao esta recolhida, e habilita o hover para espandir ela
  @media (min-width: ${size.laptopM}) {
    &:hover {
      ${props =>
        props.$mini &&
        css`
          width: 230px;
          /* display: flex; */
          svg {
            font-size: 20px !important;
          }
          p {
            -webkit-transition: all 0.2s ease 0.05s;
            transition: all 0.2s ease 0.05s;
            -webkit-transform: translateZ(0);
            transform: translateZ(0);
            opacity: 1;
            color: #fff;
          }
          b {
            opacity: 1 !important;
          }

          div {
            -webkit-transition: all 0.2s ease 0s;
            transition: all 0.2s ease 0.08s;
            -webkit-transform: translateZ(0);
            transform: translateZ(0);
            opacity: 1;
            color: #fff;
          }

          h5 {
            opacity: 0;
          }
        `}
    }
  }
`;

export const Menu = styled.ul`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Logo = styled.div`
  position: relative;
  padding: 0.5rem 0.2rem 0rem;
  z-index: 4;
  display: flex;
  flex-direction: row;
  align-items: center;
  -webkit-transition: all 0.2s ease 0s;
  -o-transition: all 0.2s ease 0s;
  transition: all 0.2s ease 0s;

  img {
    width: auto;
  }

  p {
    font-size: 1.2625rem;
    margin-left: 5px;
    font-weight: 600;
    color: hsla(0, 0%, 100%, 0.9);
    opacity: ${props => (props.$mini ? 0 : 1)};
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    right: 15px;
    height: 1px;
    width: calc(100% - 30px);
    background: hsla(0, 0%, 100%, 0.5);
  }
`;

export const Content = styled.div`
  /*quando for abrir o padding-left será 280px; */
  /* display: flex; */
  /* color: #fff; */
  width: 100%;
  padding-left: ${props => (props.$mini ? '90px' : '240px')};
  background: ${props => props.theme.background};
  overflow-x: hidden;
  height: -webkit-fill-available;
  position: fixed;

  @media ${device.laptopM} {
    padding-left: 0px;
  }
`;
